<script lang="ts">
	import { get } from 'svelte/store';
	//Formating
	import { format } from 'svelte-i18n';
	// Design system components
	import { Alert, Button, Modal, Text } from '@Shelly/shelly-design-system';
	import { push, replace } from 'svelte-spa-router';
	import { capFirstChar } from 'src/helpers/utilities';
	import { getLandingHref } from 'src/helpers/main_menu';
	import { wait } from 'src/helpers/utilities';

	export let showNetMeteringModal: boolean;
</script>

<Modal
	title={$format('feature_nm_name', {
		default: 'Net Metering Support',
	})}
	on:close={() => {
		showNetMeteringModal = false;
	}}
	showModal={showNetMeteringModal}
>
	<svelte:fragment slot="content">
		<Text class="mb-m">
			{$format('description_dummy_net_metering', {
				default: 'App Based Energy Net Metering calculation is based only on 1-hour resolution.',
			})}
		</Text>
		<Alert
			isHeadingBold
			type="info"
			heading={capFirstChar(
				$format('lower_res_support_heading', {
					default: 'Check out the lower resolution options',
				}),
			)}
			message={capFirstChar(
				$format('lower_res_support_message', {
					default:
						'Lower resolutions such as <strong>30min, 15min</strong>, etc. are supported by the Device Energy Based Net Metering.',
				}),
			)}
			cta={{
				title: capFirstChar(
					$format('link_learn_more', {
						default: 'Find out more',
					}),
				),
			}}
			on:cta_click={async () => {
				showNetMeteringModal = false;
				replace(getLandingHref());
				await wait(100);
				push('/settings/user?experimentalFeatures');
			}}
		/>
	</svelte:fragment>
	<div slot="footer" class="d-flex justify-content-end">
		<Button
			variant="primary"
			on:click={() => {
				showNetMeteringModal = false;
			}}
		>
			{$format('button_close', {
				default: 'Close',
			})}
		</Button>
	</div>
</Modal>
